import useLoad from 'components/hooks/useLoad';
import {integrityInstance} from 'constants/url';

function useLoadIntegrityinstance(selection: any) {
  return useLoad(integrityInstance, 'revision', selection);
}

export default useLoadIntegrityinstance;
